/**
 * How a task status reads on the Audit Insights rows: its label, and the badge it is shown
 * in.
 *
 * Both come from the maps `shared/ui/ListCard` already owns, so this tab cannot drift from
 * the audit and task lists. Nothing here decides what a status *means*, or what colour it
 * is drawn in — Stencil's `Badge` colours itself from the severity, and that severity is
 * decided in one place.
 */
import { BadgeType } from '@amzn/stencil-react-components/badge';

import { STATUS_BADGE_TYPE, STATUS_DISPLAY_LABEL } from 'src/v2/shared/ui/ListCard';

/** The shared maps as lookups, so reading one is not a dynamic property read. */
const LABELS = new Map(Object.entries(STATUS_DISPLAY_LABEL));
const BADGE_TYPES = new Map(Object.entries(STATUS_BADGE_TYPE));

/**
 * The status as a reader should see it. Helios spells it `IN_PROGRESS`.
 *
 * An unmapped status falls through to the raw value, which is visible rather than blank,
 * so a status Helios adds shows up as something to map.
 */
export function taskStatusLabel(taskStatus: string): string {
  return LABELS.get(taskStatus) ?? taskStatus;
}

/** The badge a status is shown in, neutral for one this build does not recognise. */
export function taskStatusBadgeType(taskStatus: string): BadgeType {
  return BADGE_TYPES.get(taskStatus) ?? BadgeType.Neutral;
}
